import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users, Mail, CheckCircle2, TrendingUp } from "lucide-react";

interface ReferralFunnelMetricsProps {
  totalMainSubmissions: number;
  totalInvited: number;
  totalResponded: number;
  conversionRate: number;
}

export function ReferralFunnelMetrics({
  totalMainSubmissions,
  totalInvited,
  totalResponded,
  conversionRate,
}: ReferralFunnelMetricsProps) {
  const pendingCount = totalInvited - totalResponded;

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {/* Encuestas Principales */}
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">
            Encuestas Principales
          </CardTitle>
          <Users className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{totalMainSubmissions}</div>
          <p className="text-xs text-muted-foreground">
            Participantes que invitaron referidos
          </p>
        </CardContent>
      </Card>

      {/* Total Invitados */}
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">
            Referidos Invitados
          </CardTitle>
          <Mail className="h-4 w-4 text-blue-500" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-blue-600">{totalInvited}</div>
          <p className="text-xs text-muted-foreground">
            Emails de referidos registrados
          </p>
        </CardContent>
      </Card>

      {/* Respondidos */}
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">
            Han Respondido
          </CardTitle>
          <CheckCircle2 className="h-4 w-4 text-green-500" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-green-600">{totalResponded}</div>
          <p className="text-xs text-muted-foreground">
            <span className="text-amber-600 font-medium">{pendingCount} pendientes</span>
            {" "}de responder
          </p>
        </CardContent>
      </Card>

      {/* Tasa de Conversión */}
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">
            Tasa de Conversión
          </CardTitle>
          <TrendingUp className="h-4 w-4 text-purple-500" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-purple-600">{conversionRate}%</div>
          <p className="text-xs text-muted-foreground">
            Referidos que completaron encuesta
          </p>
          {/* Barra de progreso visual */}
          <div className="mt-2 h-2 w-full rounded-full bg-gray-200">
            <div
              className="h-2 rounded-full bg-gradient-to-r from-purple-500 to-purple-600 transition-all duration-500"
              style={{ width: `${Math.min(conversionRate, 100)}%` }}
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
